<template>
  <table class="table">
    <thead>
        <tr><th class="wc1">Degree</th><th class="wc2">Notes</th><th>Name</th><th>Description</th></tr>
     </thead>
    <tbody>
      <tr v-for="degree in 7">
        <td>{{getRoman(degree)}}</td>
        <td>{{getNotes(degree)}}</td>
        <td>{{getName(degree)}}</td>
        <td>{{getName(degree,false)}}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
  import * as MusicData from '@/data/music_data'

  export default {
    name: 'ChordsSheet',
    props: {
      rootKey: {
        type: String,
        default: 'C'
      },
      triad: {
        type: String,
        default: 'major'
      },
      tetra: {
        type: String,
        default: 'none'
      }
    },
    data () {
      return {
        majorScale: [],
        chromaticScale: [],
      }
    },
    mounted: function () {
      this.majorScale = MusicData.majorScale;
      this.chromaticScale = MusicData.chromaticScales[this.rootKey]
      this.romanDegrees = MusicData.romanDegrees
    },
    /* eslint-disable no-unused-vars */
    watch: {
      rootKey: function (newKey, oldKey) {
        this.chromaticScale = MusicData.chromaticScales[newKey]
      },
    },
    computed: {
    },
    methods: {
      hasValue (value,index) {
        return value !== "" && typeof this.chromaticScale !== 'undefined'
      },
      getRoman(degree) {
        return MusicData.romanDegrees[degree];
      },
      getNotes (degree) {
        let chord = this.getChord(degree);
        return chord.join(" - ");
      },
      getName (degree,getname=true) {
        let chord = this.getChord(degree);
        return MusicData.getChordName(chord,getname);
      },
      getChord(degree) {
        let chord = [];
        let chordScale = MusicData.chordScales[degree-1];

        // get tonic note
        chord.push(this.chromaticScale[chordScale.indexOf(1)]);
        // get dominant note
        chord.push(this.chromaticScale[chordScale.indexOf(5)]);

        // get third note
        if (this.triad === "major")
          chord.push(this.chromaticScale[chordScale.indexOf(3)]);
        else if (this.triad === "minor") {
          let pos = (chordScale.indexOf(3) > 0) ? chordScale.indexOf(3) : chordScale.length;
          chord.push(this.chromaticScale[pos-1]);
        }
        else if (this.triad === "sus4") {
          let pos = (chordScale.indexOf(3) < chordScale.length-1) ? chordScale.indexOf(3) : 0;
          chord.push(this.chromaticScale[pos+1]);
        }

        // get seventh note
        if (this.tetra === "minor7") {
          let pos = (chordScale.indexOf(7) > 0) ? chordScale.indexOf(7) : chordScale.length;
          chord.push(this.chromaticScale[pos-1]);
        }
        else if (this.tetra === "major6") {
          let pos = (chordScale.indexOf(7) > 0) ? chordScale.indexOf(7) : chordScale.length;
          chord.push(this.chromaticScale[pos-2]);
        }
        else if (this.tetra === "major7") {
          chord.push(this.chromaticScale[chordScale.indexOf(7)]);
        }

        return chord;
      }
    }
  }
</script>

<style>
.wc1 {
  width: 10%
}
.wc2 {
  width: 15%
}
</style>
